import type * as Types from '../../../schemas/shopify/admin.types';

import { PickPageArticleNodeFragmentDoc } from '../fragments/pickPageArticle.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcherGemX } from '../../utils/gatewayClientGemX';
export type PickPageArticlesQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sortKey?: Types.InputMaybe<Types.ArticleSortKeys>;
  reverse?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type PickPageArticlesQueryResponse = {
  articles: {
    edges: Array<
      Pick<Types.ArticleEdge, 'cursor'> & {
        node: Pick<Types.Article, 'id' | 'handle' | 'title' | 'isPublished' | 'templateSuffix'> & {
          blog: Pick<Types.Blog, 'handle'>;
          image?: Types.Maybe<Pick<Types.Image, 'url'>>;
        };
      }
    >;
    pageInfo: Pick<Types.PageInfo, 'hasNextPage' | 'endCursor'>;
  };
};

export const PickPageArticlesDocument = `
    query PickPageArticles($first: Int!, $after: String, $query: String, $sortKey: ArticleSortKeys, $reverse: Boolean) {
  articles(
    first: $first
    after: $after
    query: $query
    sortKey: $sortKey
    reverse: $reverse
  ) {
    edges {
      cursor
      node {
        ...PickPageArticleNode
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PickPageArticleNodeFragmentDoc}`;

export const usePickPageArticlesQuery = <TData = PickPageArticlesQueryResponse, TError = unknown>(
  variables: PickPageArticlesQueryVariables,
  options?: UseQueryOptions<PickPageArticlesQueryResponse, TError, TData>,
) => {
  return useQuery<PickPageArticlesQueryResponse, TError, TData>(
    ['PickPageArticles', variables],
    appFetcherGemX<PickPageArticlesQueryResponse, PickPageArticlesQueryVariables>(
      PickPageArticlesDocument,
      variables,
    ),
    options,
  );
};

usePickPageArticlesQuery.getKey = (variables: PickPageArticlesQueryVariables) => [
  'PickPageArticles',
  variables,
];
